import { useEffect } from 'react';

export const useVisibilityChange = ({ isActive = true, onVisible }: { isActive: boolean; onVisible: () => void }) => {
  useEffect(() => {
    if (isActive) {
      const handleVisibility = () => {
        if (document.visibilityState === 'visible') {
          onVisible();
        }
      };
      document.addEventListener('visibilitychange', handleVisibility);
      return () => {
        document.removeEventListener('visibilitychange', handleVisibility);
      };
    }
  }, [isActive, onVisible]);
};
